const FILTER_CATEGORIES_SELECTOR = ".js-article-list-filter"
const ARTICLE_LIST_SELECTOR = ".js-article-list"
const CATEGORY_ACTIVE_CLASS = "blog-categories__list-item--active"
const ARTICLE_HIDE_CLASS = "article-list__item--hidden"

export function initBlog() {
  const categoriesElement = document.querySelector(FILTER_CATEGORIES_SELECTOR)
  const articleListElement = document.querySelector(ARTICLE_LIST_SELECTOR)

  if (!categoriesElement || !articleListElement) {
    return
  }

  const articles = Array.from(
    articleListElement.querySelectorAll(".article-list__item")
  )
  let activeCategory = "All"

  function handleActiveCategory(category) {
    // Remove current active class
    categoriesElement
      .querySelectorAll("li")
      .forEach((element) => element.classList.remove(CATEGORY_ACTIVE_CLASS))

    // Find a element of new category and make it active
    categoriesElement
      .querySelector(`[data-filter-category="${category}"]`)
      .classList.add(CATEGORY_ACTIVE_CLASS)

    // Set category to be active
    activeCategory = category
  }

  function highlightFirstArticle() {
    const firstArticle = articles.find(
      (article) => !article.classList.contains(ARTICLE_HIDE_CLASS)
    )

    if (!firstArticle) {
      return
    }

    firstArticle.classList.add("article-list__item--featured")
    firstArticle
      .querySelector(".article-card")
      .classList.add("article-card--horizontal")
  }

  function resetClassesBeforeFilter() {
    for (const article of articles) {
      article.classList.remove("article-list__item--featured")

      article.classList.remove(ARTICLE_HIDE_CLASS)

      article
        .querySelector(".article-card")
        .classList.remove("article-card--horizontal")
    }
  }

  function filterArticles(category) {
    resetClassesBeforeFilter()

    if (category === "All") {
      highlightFirstArticle()
      return
    }

    for (const article of articles) {
      const category = article.getAttribute("data-category-name")

      if (category !== activeCategory) {
        article.classList.add(ARTICLE_HIDE_CLASS)
      } else {
        article.classList.remove(ARTICLE_HIDE_CLASS)
      }
    }

    // Adjust first child
    highlightFirstArticle()
  }

  const categories = Array.from(categoriesElement.querySelectorAll("li"))

  for (const category of categories) {
    category.addEventListener("click", (event) => {
      const category = event.target.getAttribute("data-filter-category")
      handleActiveCategory(category)
      filterArticles(category)
    })
  }

  handleActiveCategory(activeCategory)
  filterArticles(activeCategory)
}
